<div class="row">
	<!-- <div class="col-md-1 col-sm-1 col-xs-1">

	</div> -->
	<div class="col-md-12" *ngIf='imagelink'>
		<div class="blocimage d-flex" style="gap: 20px;">
			<div class="col-md-4">
				<img [src]="imagelink" class="imgCover" />
			</div>
			<div class="col-md-8" style="padding-right:20px;">
				<div (click)="imgFileInput.click()" class="btn-default text-center">
					<!-- <button type="button" md-button><img src="../../../assets/images/drop-img.png" /></button> -->
					<input hidden type="file" #imgFileInput (change)="selectFile($event)" accept='.jpeg, .jpg , .png' />
					<button [disabled]="selectedFiles">change your image here <svg width="20" height="20"
							viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
								stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</button>
				</div>
				<div class="blocUpload">
					<p class="separator">Or</p>
					<button class="link-Btn" (click)="URLInput()" [disabled]="selectedFiles">change image from
						URL</button>
				</div>
				<ng-container *ngIf='imageRatio'>
					<div class="form-group mt-3">
						<label class=" Label__Text">Change image ratio</label>
						<mat-select (selectionChange)="changeImageRatio($event)" placeholder="Choose ratio">
							<mat-option value="square"> Square</mat-option>
							<mat-option value="horizontal"> Horizontal </mat-option>
						</mat-select>
					</div>
				</ng-container>
			</div>
		</div>
		<!-- elseeeeee -->
		<div [ngClass]=" imagelink || image ? 'affichage1n': 'affichage1'">
			<div class="row blocimage">
				<div class="affichage">
					<div *ngIf='imagelink'>
						<img [src]="imagelink" />
					</div>
					<div *ngIf='image'>
						<img [src]="image" />
					</div>

					<div [ngClass]=" imagelink || image ? 'image1n': 'image1'" class="row">

						<div class="col-md-4 col-sm-4 col-xs-4">
							<img src="../../../assets/images/no-img.png" />
						</div>
						<div class="col-md-7 col-sm-7 col-xs-7">
							<div (click)="imgFileInput.click()" class="img1">


								<!-- <button type="button" md-button><img src="../../../assets/images/drop-img.png" /></button> -->
								<input hidden type="file" #imgFileInput (change)="selectFile($event)"
									accept='.jpeg, .jpg , .png' />
								<button style="color: #5e5e5e!important;" class="btn-successs"
									[disabled]="selectedFiles">Upload your image here <mat-icon
										fontIcon="add_circle"></mat-icon><br></button>
							</div>
							<div class="flex-container">
								<span style="text-align: center; color: #5e5e5e!important; display: block;">or</span>
								<button style="font-size: 11px; " class="btn-successs" (click)="URLInput()"
									[disabled]="selectedFiles">Add image from URL</button>
							</div>


							<ng-container *ngIf='imageRatio'>
								<label class="Label__Text">Change image ratio</label>

								<mat-select (selectionChange)="changeImageRatio($event)" placeholder="Choose ratio">
									<mat-option value="square"> Square</mat-option>
									<mat-option value="horizontal"> Horizontal </mat-option>
								</mat-select>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="col-md-1 col-sm-1 col-xs-1">
		<div class="altimg">
			<div [ngClass]=" ShowAlt  || image? 'alt2n': 'alt2'" *ngIf='ShowAlt' class="row">
				<div class="alt-image">
					<button type="button" md-button (click)="ALTInput()"> <img
							src="../../../assets/images/alt.png" /></button>
				</div>
			</div>
		</div>
	</div>
</div>